import { render } from "./main-screen.vue?vue&type=template&id=6352b2bb&scoped=true&ts=true&lang=pug"
import script from "./main-screen.vue?vue&type=script&setup=true&lang=ts"
export * from "./main-screen.vue?vue&type=script&setup=true&lang=ts"

import "./main-screen.vue?vue&type=style&index=0&id=6352b2bb&lang=stylus&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6352b2bb"]])

export default __exports__